<template>
    <div v-if="errors">
        <div v-for="error in errors" :key="error.index">
            <b-alert
                show
                dismissible
                fade
                :variant="error.type"
                v-html="error.message"
                class="d-print-none"
            ></b-alert>
        </div>
    </div>
</template>

<script>
export default {
    name: "CustomAlerts",
    props: {
        errors: Array,
    },
};
</script>
